import { render, staticRenderFns } from "./SubDesignationList.vue?vue&type=template&id=3a73a40d"
import script from "./SubDesignationList.vue?vue&type=script&lang=js"
export * from "./SubDesignationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports